/**
 * Deals with reward labels
 */
export class RewardLabels {
  /**
   * @constructor
   */
  constructor(
    public rewardDetails: string = 'reward-details', // NOSONAR
    public redeemReward: string = 'redeem-reward', // NOSONAR
    public redeemRewardDisabled: string = 'points-left-bang', // NOSONAR
    public rewardImageTitle: string = 'reward-image-title', // NOSONAR
    public errorEquipmentFetch: string = 'generic-error' // NOSONAR
  ) {}
}
